import { useTranslation } from 'react-i18next'
import '../../i18n/i18n'
import Image from 'next/image'
import { Heading, Variant, Style } from '../../components/Heading'

import {
  getStrapiBlogArticle,
  getBlogPostResponse,
  getHeaderQuery,
} from '../../lib/strapi/queries'
import { getStrapiMedia, strapiDateToString } from '../../lib/strapi/helpers'
import { BlogPostType, Header, HeaderQuery } from '../../lib/strapi/responseTypes'
import BlogArticlePage from '../../components/templates/BlogArticlePage'
import { IS_PRODUCTION } from '../../config'
import { GetStaticProps } from 'next'

type ParamsType = {
  slug: string
}

type BlogPostPageType =  {blogPost: BlogPostType,  headerData: Header}

export default function Blog({blogPost, headerData}: BlogPostPageType) {
  const { t: translate } = useTranslation()
  return (
    <>
      <BlogArticlePage
        pageTitle={`${blogPost.attributes.title} - Protect Our Winters UK`}
        description={`Protect Our Winters's blog article - ${translate(
          blogPost.attributes.title
        )}`}
        paragraph="Big ideas start small. Solving our climate crisis is no different. Start your journey to climate advocacy with our newsletter."
        source={blogPost.attributes.content}
        menuItems={headerData.data.attributes.menuItems}
      >
        <Heading
          id="main"
          className="normal-case"
          variant={Variant.h1}
          cssStyle={Style.h1}
          headingText={blogPost.attributes.title}
        />
        <span className="block">
          {strapiDateToString(blogPost.attributes.datePublished)}
        </span>
        <div className="pb-1/3.3 relative w-full">
          <Image
            src={getStrapiMedia(blogPost.attributes.bannerImage.data.attributes.url)}
            alt={blogPost.attributes.bannerImage.data.attributes.alternativeText}
            layout="fill"
            objectFit="cover"
            loader={({ src }) => {
              return src;
            }}
          />
        </div>
      </BlogArticlePage>
    </>
  )
}

export async function getStaticPaths() {
  try {
    const blogPosts = await getBlogPostResponse(!IS_PRODUCTION)
    return {
      paths: blogPosts
        ? blogPosts.blogPosts.data.map((blogPost: BlogPostType) => ({
            params: {
              slug: blogPost.attributes.slug,
            },
          }))
        : [],
      fallback: false,
    }
  } catch (error) {
    return { paths: [], fallback: false }
  }
}

export const getStaticProps: GetStaticProps<BlogPostPageType> = async(context) => {
  //DANGER
  const pageSlug = context!.params!.slug as string
  const posts = await getStrapiBlogArticle(pageSlug, !IS_PRODUCTION)

  const blogPost = posts.blogPosts.data[0]

  const headerData = await getHeaderQuery({
    showPreview: !IS_PRODUCTION,
  })
  
  return {
    props: {blogPost, headerData: headerData.header} ,
    revalidate: 1,
  }
}
